import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IncidentsResponse } from './incident.service';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/api/dashboard`;

  /** GET /api/dashboard/recent-incidents: incidents where the user is the pending Stage B/C reviewer. */
  getRecentIncidents(pageSize = 10, pageIndex = 0) {
    const params = new HttpParams().set('pageSize', pageSize).set('pageIndex', pageIndex);
    return this.http.get<IncidentsResponse>(`${this.base}/recent-incidents`, { params });
  }
}
